<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M34 10V14H38V10H34ZM22 38H26V42H22V38ZM38 22H42V26H38V22ZM22 30H26V34H22V30ZM30 22H34V26H30V22ZM8 6H24C25.1046 6 26 6.89543 26 8V24C26 25.1046 25.1046 26 24 26H8C6.89543 26 6 25.1046 6 24V8C6 6.89543 6.89543 6 8 6ZM10 10V22H22V10H10ZM14 14H18V18H14V14ZM32 6H40C41.1046 6 42 6.89543 42 8V16C42 17.1046 41.1046 18 40 18H32C30.8954 18 30 17.1046 30 16V8C30 6.89543 30.8954 6 32 6ZM32 30H40C41.1046 30 42 30.8954 42 32V40C42 41.1046 41.1046 42 40 42H32C30.8954 42 30 41.1046 30 40V32C30 30.8954 30.8954 30 32 30ZM34 34V38H38V34H34ZM8 30H16C17.1046 30 18 30.8954 18 32V40C18 41.1046 17.1046 42 16 42H8C6.89543 42 6 41.1046 6 40V32C6 30.8954 6.89543 30 8 30ZM10 34V38H14V34H10Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
